import React from "react";
import { Icon } from "../";

const BrandCard = ({ brand, onViewDetails, onDelete }) => {
  const getBorderColor = () => {
    return brand.enabled ? "border-green-500/50" : "border-red-500/50";
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    onDelete && onDelete(brand);
  };

  return (
    <div
      className={`cursor-pointer rounded-lg border-2 bg-gray-900 p-4 transition-colors hover:bg-gray-800 ${getBorderColor()}`}
      onClick={onViewDetails}
    >
      {/* Brand Info */}
      <div className="space-y-2">
        {/* Logo and Name */}
        <div className="flex items-center space-x-3">
          {brand.logo ? (
            <img
              src={brand.logo}
              alt={brand.name}
              className="h-12 w-12 flex-shrink-0 rounded-lg object-cover"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          ) : (
            <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-gray-800">
              <Icon name="Building" className="h-6 w-6 text-gray-400" />
            </div>
          )}

          <div className="min-w-0 flex-1">
            <h3 className="line-clamp-2 text-sm leading-tight font-semibold text-white">
              {brand.name || brand?.internal_name}
            </h3>
            <p className="mt-1 text-xs text-gray-400">
              {brand?.internal_name || ""}
            </p>
          </div>
        </div>
      </div>

      {/* Footer - View Details and Delete */}
      <div className="mt-2 border-t border-gray-700 pt-3">
        <div className="flex items-center justify-between">
          <button
            onClick={handleDeleteClick}
            className="flex items-center space-x-1 text-red-400 transition-colors hover:text-red-300"
          >
            <Icon name="Trash2" className="h-4 w-4" />
            <span className="text-xs">Delete</span>
          </button>
          <div className="flex items-center justify-end text-blue-400 transition-colors hover:text-blue-300">
            <span className="mr-1 text-xs">View Details</span>
            <Icon name="ChevronRight" className="h-3 w-3" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandCard;
